export type TimeZoneType = {
    id: number;
    description: string;
}

export const TIMEZONETYPES = {
    PROCESSING_TIME: "Processing Time Zone",
    LOCAL_TIME: "Local Time Zone of the Transaction",   
  };

export const TimeZoneTypes: Array<TimeZoneType> = [
    { id: 0, description:TIMEZONETYPES.PROCESSING_TIME},
    { id: 1, description:TIMEZONETYPES.LOCAL_TIME},    
]